document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('submit', function (event) {
        if (!event.target.matches('#newsletter-form')) return;
        event.preventDefault();

        const form          = event.target;
        const formContainer = form.closest('.js-newsletter-form');
        const params        = new URLSearchParams(new FormData(form));
        params.append('action', 'submit-newsletter-ajax');
        params.append('nonce', variables.newsletter_nonce);

        fetch(urls.ajax, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: params,
        })
            .then(r => r.json())
            .then(response => {
                if (formContainer) formContainer.innerHTML = response.data.form;
            })
            .catch(() => {});
    });
});
